import {
  FocusContext,
  setFocus,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { useEffect } from 'react'

import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import tts from '../../lib/TTS.js'

import { ErrorBody } from '../../../../shared/PBSError'
import ErrorDescription from '../../components/ErrorModal/ErrorDescription'
import { getErrorDescriptionDetails } from '../../lib/helpers'
import { ManageDonationComponentsEnums } from './types'

const BUTTON_KEY = 'BACK'

type CancelDonationErrorProps = {
  error: ErrorBody
  onEnterPress: (arg0: ManageDonationComponentsEnums) => void
}

// eslint-disable-next-line import/prefer-default-export
export function CancelDonationError({
  error,
  onEnterPress,
}: CancelDonationErrorProps) {
  const { ref } = useFocusable()
  const pbsError = error.errorMessage.e

  const { errorText, errorCodePrefix, errorDetails } =
    getErrorDescriptionDetails(pbsError)

  const errorTitle = 'We encountered a problem while cancelling your donations'

  useEffect(() => {
    tts.addTextToRead(
      `${errorTitle} ... ${errorText} ... ${errorCodePrefix} ... ${errorDetails}.`
    )
    setFocus(BUTTON_KEY)
  }, [])

  const handleEnterPress = () => {
    onEnterPress(ManageDonationComponentsEnums.ROOT)
    tts.enqueueTextToRead('Pressed go back button.')
  }

  const handleFocus = () => {
    tts.enqueueTextToRead('Focus on go back button.')
  }

  return (
    <FocusContext.Provider value="cancel-donation-error">
      <div className="cancellation-donation-screen__error" ref={ref}>
        <h1 className="cancellation-donation-screen__error__title">
          {errorTitle}
        </h1>
        <ErrorDescription e={pbsError} />
        <FocusableButtonTS
          onEnterPress={handleEnterPress}
          onFocus={handleFocus}
          className="cancellation-donation-screen__error__back-button"
          focusKey={BUTTON_KEY}
        >
          Go back
        </FocusableButtonTS>
      </div>
    </FocusContext.Provider>
  )
}
